import Organization from "@/models/Organization";

export default class User {
    public id!: number;
    public email!: string;
    public firstName!: string;
    public lastName!: string;

    public active!: boolean;
    public ldapUser!: boolean;
    public paymentToken!: string;
    public role!: string;
    public password!: string;
    public accountKey!: string;
    public accountKeyIv!: string;

    public organizations: Organization[] = [];

    static createEmpty(): User {
        const result = new User();
        result.id = 0;
        result.email = "";
        result.firstName = "";
        result.lastName = "";
        result.active = false;
        result.paymentToken = "";
        return result;
    }
}
